function extractOrigin(url) {
  try {
    const { origin } = new URL(url)
    return origin
  } catch {
    return url.replace(/\/$/, '')
  }
}

export const BACKEND_ORIGIN = extractOrigin(import.meta.env.VITE_JSON_SERVER_URL || 'http://localhost:8000')

export const JSON_SERVER_URL = BACKEND_ORIGIN

export function jsonServerUrl(path = '') {
  if (!path) return BACKEND_ORIGIN
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${BACKEND_ORIGIN}${normalizedPath}`
}
